// extracted by mini-css-extract-plugin
export default {"expenseListContainer":"ExpenseList_expenseListContainer__GK+tW","transactionList":"ExpenseList_transactionList__r+BJN"};